import { jsx as e } from "react/jsx-runtime";
import { useState as t, useEffect as a } from "react";
import o from "./FileUploader.js";
import { urlToFile as n, toBase64 as i } from "./util/index.js";
const r = "logo.png", p = ({ value: p2, defaultFilename: l = r, onChange: c, accept: m = ".png, .jpg, .jpeg, .svg", description: s = "" }) => {
  const [d, g] = t();
  return a(() => {
    (async () => {
      g(p2 ? await n(p2, l, "text/plain") : void 0);
    })();
  }, [l, p2]), e(o, { defaultFilename: r, accept: m, description: s, onChange: (e2) => e2 ? i(e2).then(c) : c(), value: d });
};
export {
  p as ImageUploader,
  p as default
};
//# sourceMappingURL=ImageUploader.js.map
